import { render, staticRenderFns } from "./c_pictrue.vue?vue&type=template&id=76c2904a&scoped=true"
import script from "./c_pictrue.vue?vue&type=script&lang=js"
export * from "./c_pictrue.vue?vue&type=script&lang=js"
import style0 from "./c_pictrue.vue?vue&type=style&index=0&id=76c2904a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c2904a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76c2904a')) {
      api.createRecord('76c2904a', component.options)
    } else {
      api.reload('76c2904a', component.options)
    }
    module.hot.accept("./c_pictrue.vue?vue&type=template&id=76c2904a&scoped=true", function () {
      api.rerender('76c2904a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageDiy/mobileConfigRight/c_pictrue.vue"
export default component.exports